// Cardrive admin mock data. Direct port of cardrive/admin-data.jsx so the
// scaffold can render identical screens before the /admin/* API endpoints
// land in PR 2.7. Replace each `MOCK_*` import with a real `useQuery`
// against the Hono `/admin/*` endpoints once they're built.

export type BookingStatus =
  | 'requested'
  | 'confirmed'
  | 'active'
  | 'completed'
  | 'cancelled'
  | 'disputed'
  | 'refunded';

export interface MockBooking {
  id: string;
  code: string;
  status: BookingStatus;
  guest: string;
  guestEmail: string;
  car: string;
  carSlug: string;
  vendor: string;
  city: string;
  pickup: string;
  ret: string;
  days: number;
  total: number;
  payout: number;
  fee: number;
  ins: 'Standard' | 'Premium';
  flagged: boolean;
  channel: 'web' | 'app' | 'phone';
  created: string;
  deliveryFee: number;
}

export const MOCK_BOOKINGS: MockBooking[] = [
  { id: 'BK-48201', code: 'BK-48201', status: 'active', guest: 'Tom Bagshaw', guestEmail: 'tom.b@gmail.com', car: 'Tesla Model Y', carSlug: 'tesla-model-y-london', vendor: 'Priya · All-Star', city: 'London', pickup: 'Sat 30 May · 10:00', ret: 'Mon 1 Jun · 10:00', days: 2, total: 168, payout: 126, fee: 42, ins: 'Standard', flagged: false, channel: 'web', created: '14 May 14:32', deliveryFee: 12 },
  { id: 'BK-48199', code: 'BK-48199', status: 'requested', guest: 'Jana Klein', guestEmail: 'jana.k@protonmail.com', car: 'Vauxhall Cascada', carSlug: 'vauxhall-cascada-london', vendor: 'Hamzal · Superhost', city: 'London', pickup: 'Fri 6 Jun · 09:00', ret: 'Sun 8 Jun · 19:00', days: 2, total: 150, payout: 112, fee: 38, ins: 'Premium', flagged: true, channel: 'app', created: '15 May 09:14', deliveryFee: 0 },
  { id: 'BK-48198', code: 'BK-48198', status: 'confirmed', guest: 'Aïcha Mansouri', guestEmail: 'aicha@me.com', car: 'Land Rover Disco', carSlug: 'land-rover-disco-edi', vendor: 'Jules · 6y hosting', city: 'Edinburgh', pickup: 'Wed 12 Jun · 11:00', ret: 'Tue 18 Jun · 11:00', days: 6, total: 504, payout: 378, fee: 126, ins: 'Premium', flagged: false, channel: 'web', created: '15 May 11:02', deliveryFee: 0 },
  { id: 'BK-48197', code: 'BK-48197', status: 'completed', guest: 'Marcus Wong', guestEmail: 'm.wong@outlook.com', car: 'BMW 1 Series', carSlug: 'bmw-1-series-london', vendor: 'Marek · 4y hosting', city: 'London', pickup: 'Mon 5 May · 08:00', ret: 'Wed 7 May · 20:00', days: 2, total: 132, payout: 99, fee: 33, ins: 'Standard', flagged: false, channel: 'web', created: '02 May 19:44', deliveryFee: 0 },
  { id: 'BK-48196', code: 'BK-48196', status: 'disputed', guest: 'Sara Ahmadi', guestEmail: 'sara.a@yahoo.com', car: 'Volkswagen Polo', carSlug: 'vw-polo-lisbon', vendor: 'Sara · 2y hosting', city: 'Lisbon', pickup: 'Mon 28 Apr · 14:00', ret: 'Thu 1 May · 14:00', days: 3, total: 108, payout: 0, fee: 27, ins: 'Standard', flagged: true, channel: 'app', created: '21 Apr 16:11', deliveryFee: 8 },
  { id: 'BK-48195', code: 'BK-48195', status: 'cancelled', guest: 'Liam OConnor', guestEmail: 'liam@oc.ie', car: 'Mini Cooper SE', carSlug: 'mini-cooper-se-london', vendor: 'Tom · All-Star', city: 'London', pickup: 'Sat 17 May · 10:00', ret: 'Sun 18 May · 18:00', days: 2, total: 0, payout: 0, fee: 0, ins: 'Standard', flagged: false, channel: 'web', created: '10 May 10:33', deliveryFee: 0 },
  { id: 'BK-48194', code: 'BK-48194', status: 'completed', guest: 'Helena Costa', guestEmail: 'h.costa@pt', car: 'Porsche 911', carSlug: 'porsche-911-mallorca', vendor: 'Lluís · Pro Fleet', city: 'Mallorca', pickup: 'Sat 3 May · 09:00', ret: 'Sat 10 May · 09:00', days: 7, total: 1820, payout: 1365, fee: 455, ins: 'Premium', flagged: false, channel: 'web', created: '24 Apr 12:21', deliveryFee: 30 },
  { id: 'BK-48193', code: 'BK-48193', status: 'active', guest: 'Kenji Yamamoto', guestEmail: 'kenji@y.jp', car: 'Range Rover Velar', carSlug: 'range-rover-mar', vendor: 'Karim · Marrakesh', city: 'Marrakesh', pickup: 'Sat 11 May · 09:00', ret: 'Sat 18 May · 09:00', days: 7, total: 658, payout: 493, fee: 165, ins: 'Premium', flagged: false, channel: 'web', created: '01 May 17:08', deliveryFee: 0 },
  { id: 'BK-48192', code: 'BK-48192', status: 'completed', guest: 'Ingrid Solberg', guestEmail: 'i@solberg.no', car: 'Fiat 500', carSlug: 'fiat-500-rey', vendor: 'Eyrún · Reykjavík', city: 'Reykjavík', pickup: 'Sat 26 Apr · 14:00', ret: 'Tue 29 Apr · 14:00', days: 3, total: 165, payout: 124, fee: 41, ins: 'Standard', flagged: false, channel: 'web', created: '12 Apr 09:45', deliveryFee: 0 },
  { id: 'BK-48191', code: 'BK-48191', status: 'requested', guest: 'Olamide Adeyemi', guestEmail: 'ola@ade.ng', car: 'VW California', carSlug: 'vw-california-cape', vendor: 'Sipho · Cape Fleet', city: 'Cape Town', pickup: 'Mon 9 Jun · 10:00', ret: 'Mon 23 Jun · 10:00', days: 14, total: 1610, payout: 1208, fee: 402, ins: 'Premium', flagged: false, channel: 'app', created: '15 May 06:22', deliveryFee: 50 },
  { id: 'BK-48190', code: 'BK-48190', status: 'refunded', guest: 'Pavel Novak', guestEmail: 'pavel@cz', car: 'BMW i4', carSlug: 'bmw-i4-edi', vendor: 'Jules · 6y hosting', city: 'Edinburgh', pickup: 'Sat 19 Apr · 10:00', ret: 'Sun 20 Apr · 18:00', days: 2, total: 0, payout: 0, fee: 0, ins: 'Standard', flagged: false, channel: 'web', created: '11 Apr 14:18', deliveryFee: 0 },
  { id: 'BK-48189', code: 'BK-48189', status: 'completed', guest: 'Mira Andersson', guestEmail: 'mira@se', car: 'Audi RS7', carSlug: 'audi-rs7-london', vendor: 'Priya · All-Star', city: 'London', pickup: 'Thu 1 May · 18:00', ret: 'Mon 5 May · 09:00', days: 4, total: 920, payout: 690, fee: 230, ins: 'Premium', flagged: false, channel: 'web', created: '22 Apr 11:09', deliveryFee: 25 },
];

export type CarStatus = 'live' | 'paused' | 'review' | 'rejected';
export type Moderation = 'approved' | 'pending' | 'rejected';

export interface MockCar {
  id: string;
  slug: string;
  name: string;
  year: number;
  plate: string;
  vendor: string;
  vendorId: string;
  city: string;
  status: CarStatus;
  day: number;
  occupancy: number;
  trips: number;
  rating: number;
  fuel: 'Electric' | 'Petrol' | 'Diesel' | 'Hybrid';
  trans: 'Auto' | 'Manual';
  img: string;
  moderation: Moderation;
}

export const MOCK_CARS: MockCar[] = [
  { id: 'CAR-1042', slug: 'tesla-model-y-london', name: 'Tesla Model Y', year: 2023, plate: 'LP23 KFE', vendor: 'Priya · All-Star', vendorId: 'V-018', city: 'London', status: 'live', day: 70, occupancy: 0.78, trips: 88, rating: 4.97, fuel: 'Electric', trans: 'Auto', img: 'https://images.unsplash.com/photo-1617788138017-80ad40651399?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1041', slug: 'vauxhall-cascada-london', name: 'Vauxhall Cascada', year: 2016, plate: 'EX16 PRD', vendor: 'Hamzal · Superhost', vendorId: 'V-007', city: 'London', status: 'live', day: 50, occupancy: 0.94, trips: 312, rating: 4.99, fuel: 'Petrol', trans: 'Auto', img: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1040', slug: 'bmw-1-series-london', name: 'BMW 1 Series', year: 2017, plate: 'YK17 NLA', vendor: 'Marek · 4y hosting', vendorId: 'V-031', city: 'London', status: 'paused', day: 44, occupancy: 0.42, trips: 274, rating: 4.88, fuel: 'Petrol', trans: 'Manual', img: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1039', slug: 'land-rover-disco-edi', name: 'Land Rover Disco', year: 2019, plate: 'SK19 OWD', vendor: 'Jules · 6y hosting', vendorId: 'V-004', city: 'Edinburgh', status: 'live', day: 56, occupancy: 0.68, trips: 206, rating: 4.95, fuel: 'Diesel', trans: 'Auto', img: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1038', slug: 'vw-polo-lisbon', name: 'Volkswagen Polo', year: 2020, plate: '20-AA-72', vendor: 'Sara · 2y hosting', vendorId: 'V-052', city: 'Lisbon', status: 'review', day: 36, occupancy: 0.55, trips: 142, rating: 4.91, fuel: 'Petrol', trans: 'Manual', img: 'https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=900&q=80', moderation: 'pending' },
  { id: 'CAR-1037', slug: 'mini-cooper-se-london', name: 'Mini Cooper SE', year: 2022, plate: 'BT22 LXM', vendor: 'Tom · All-Star', vendorId: 'V-019', city: 'London', status: 'live', day: 58, occupancy: 0.81, trips: 64, rating: 4.99, fuel: 'Electric', trans: 'Auto', img: 'https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1036', slug: 'porsche-911-mallorca', name: 'Porsche 911', year: 2021, plate: '4218-LBC', vendor: 'Lluís · Pro Fleet', vendorId: 'V-061', city: 'Mallorca', status: 'live', day: 260, occupancy: 0.62, trips: 41, rating: 5.0, fuel: 'Petrol', trans: 'Auto', img: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1035', slug: 'range-rover-mar', name: 'Range Rover Velar', year: 2022, plate: '1287-A-21', vendor: 'Karim · Marrakesh', vendorId: 'V-074', city: 'Marrakesh', status: 'live', day: 94, occupancy: 0.71, trips: 88, rating: 4.93, fuel: 'Diesel', trans: 'Auto', img: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1034', slug: 'fiat-500-rey', name: 'Fiat 500', year: 2020, plate: 'RY-204', vendor: 'Eyrún · Reykjavík', vendorId: 'V-090', city: 'Reykjavík', status: 'live', day: 55, occupancy: 0.84, trips: 188, rating: 4.96, fuel: 'Petrol', trans: 'Manual', img: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1033', slug: 'vw-california-cape', name: 'VW California', year: 2019, plate: 'CA-71-NB', vendor: 'Sipho · Cape Fleet', vendorId: 'V-099', city: 'Cape Town', status: 'paused', day: 115, occupancy: 0.34, trips: 51, rating: 4.88, fuel: 'Diesel', trans: 'Auto', img: 'https://images.unsplash.com/photo-1597800007133-c8b59b1f43cb?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
  { id: 'CAR-1032', slug: 'bmw-i4-edi', name: 'BMW i4', year: 2023, plate: 'SE23 RDA', vendor: 'Jules · 6y hosting', vendorId: 'V-004', city: 'Edinburgh', status: 'rejected', day: 78, occupancy: 0, trips: 0, rating: 0, fuel: 'Electric', trans: 'Auto', img: 'https://images.unsplash.com/photo-1610915099979-e16e1c2f3e6b?auto=format&fit=crop&w=900&q=80', moderation: 'rejected' },
  { id: 'CAR-1031', slug: 'audi-rs7-london', name: 'Audi RS7', year: 2022, plate: 'KS22 ABO', vendor: 'Priya · All-Star', vendorId: 'V-018', city: 'London', status: 'live', day: 230, occupancy: 0.51, trips: 22, rating: 4.95, fuel: 'Petrol', trans: 'Auto', img: 'https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?auto=format&fit=crop&w=900&q=80', moderation: 'approved' },
];

export type KycState = 'verified' | 'pending' | 'review' | 'rejected';
export type OnboardingState = 'complete' | 'docs' | 'review';

export interface MockVendor {
  id: string;
  name: string;
  handle: string;
  tier: string;
  joined: string;
  city: string;
  cars: number;
  trips: number;
  rating: number;
  response: string;
  payouts: number;
  kyc: KycState;
  onboarding: OnboardingState;
  email: string;
  flagged: boolean;
}

export const MOCK_VENDORS: MockVendor[] = [
  { id: 'V-018', name: 'Priya Kowalski', handle: 'priya', tier: 'All-Star', joined: '2021-06-14', city: 'London', cars: 4, trips: 412, rating: 4.97, response: '8 min', payouts: 18420, kyc: 'verified', onboarding: 'complete', email: 'priya@kowalski.uk', flagged: false },
  { id: 'V-007', name: 'Hamzal Bisada', handle: 'hamzal', tier: 'Superhost', joined: '2020-03-02', city: 'London', cars: 2, trips: 322, rating: 4.99, response: '12 min', payouts: 22800, kyc: 'verified', onboarding: 'complete', email: 'h.bisada@gmail.com', flagged: false },
  { id: 'V-031', name: 'Marek Novák', handle: 'marek', tier: '4y hosting', joined: '2020-09-21', city: 'London', cars: 1, trips: 274, rating: 4.88, response: '24 min', payouts: 11200, kyc: 'verified', onboarding: 'complete', email: 'marek.n@cz', flagged: false },
  { id: 'V-004', name: 'Jules Carter', handle: 'jules', tier: '6y hosting', joined: '2018-04-04', city: 'Edinburgh', cars: 3, trips: 480, rating: 4.94, response: '15 min', payouts: 28100, kyc: 'verified', onboarding: 'complete', email: 'jules@carter.scot', flagged: false },
  { id: 'V-052', name: 'Sara Lopes', handle: 'sara', tier: '2y hosting', joined: '2022-11-10', city: 'Lisbon', cars: 2, trips: 142, rating: 4.91, response: '32 min', payouts: 5200, kyc: 'pending', onboarding: 'docs', email: 's.lopes@pt', flagged: true },
  { id: 'V-019', name: 'Tom Bagshaw', handle: 'tom', tier: 'All-Star', joined: '2021-08-12', city: 'London', cars: 1, trips: 64, rating: 4.99, response: '6 min', payouts: 3850, kyc: 'verified', onboarding: 'complete', email: 'tom@bag.co', flagged: false },
  { id: 'V-061', name: 'Lluís Vidal', handle: 'lluis', tier: 'Pro Fleet', joined: '2019-05-18', city: 'Mallorca', cars: 8, trips: 612, rating: 4.96, response: '4 min', payouts: 84000, kyc: 'verified', onboarding: 'complete', email: 'l.vidal@es', flagged: false },
  { id: 'V-074', name: 'Karim Bouzid', handle: 'karim', tier: 'Pro Fleet', joined: '2020-01-07', city: 'Marrakesh', cars: 5, trips: 388, rating: 4.93, response: '18 min', payouts: 31500, kyc: 'verified', onboarding: 'complete', email: 'karim@b.ma', flagged: false },
  { id: 'V-090', name: 'Eyrún Sigurðardóttir', handle: 'eyrun', tier: '3y hosting', joined: '2022-02-19', city: 'Reykjavík', cars: 2, trips: 188, rating: 4.96, response: '22 min', payouts: 9100, kyc: 'verified', onboarding: 'complete', email: 'e@sig.is', flagged: false },
  { id: 'V-099', name: 'Sipho Dlamini', handle: 'sipho', tier: 'Pro Fleet', joined: '2021-10-30', city: 'Cape Town', cars: 3, trips: 132, rating: 4.88, response: '40 min', payouts: 7800, kyc: 'review', onboarding: 'docs', email: 's@dlam.za', flagged: true },
  { id: 'V-105', name: 'Ana Restrepo', handle: 'ana', tier: 'New host', joined: '2024-04-22', city: 'Lisbon', cars: 1, trips: 4, rating: 5.0, response: '14 min', payouts: 220, kyc: 'pending', onboarding: 'docs', email: 'a.restrepo@co', flagged: false },
];

export type CustomerStatus = 'verified' | 'review' | 'pending';

export interface MockCustomer {
  id: string;
  name: string;
  email: string;
  joined: string;
  trips: number;
  spent: number;
  rating: number;
  status: CustomerStatus;
  city: string;
  flagged: boolean;
}

export const MOCK_CUSTOMERS: MockCustomer[] = [
  { id: 'C-3201', name: 'Tom Bagshaw', email: 'tom.b@gmail.com', joined: '2023-04-12', trips: 14, spent: 2340, rating: 4.98, status: 'verified', city: 'London', flagged: false },
  { id: 'C-3200', name: 'Jana Klein', email: 'jana.k@protonmail.com', joined: '2024-01-08', trips: 6, spent: 1180, rating: 4.92, status: 'verified', city: 'Berlin', flagged: false },
  { id: 'C-3199', name: 'Aïcha Mansouri', email: 'aicha@me.com', joined: '2022-09-22', trips: 21, spent: 4920, rating: 4.99, status: 'verified', city: 'Paris', flagged: false },
  { id: 'C-3198', name: 'Marcus Wong', email: 'm.wong@outlook.com', joined: '2023-11-30', trips: 8, spent: 1380, rating: 4.96, status: 'verified', city: 'London', flagged: false },
  { id: 'C-3197', name: 'Sara Ahmadi', email: 'sara.a@yahoo.com', joined: '2024-03-04', trips: 2, spent: 220, rating: 3.5, status: 'review', city: 'Lisbon', flagged: true },
  { id: 'C-3196', name: 'Liam OConnor', email: 'liam@oc.ie', joined: '2024-04-21', trips: 1, spent: 0, rating: 0, status: 'verified', city: 'Dublin', flagged: false },
  { id: 'C-3195', name: 'Helena Costa', email: 'h.costa@pt', joined: '2022-06-11', trips: 18, spent: 6840, rating: 5.0, status: 'verified', city: 'Lisbon', flagged: false },
  { id: 'C-3194', name: 'Kenji Yamamoto', email: 'kenji@y.jp', joined: '2023-08-15', trips: 11, spent: 3420, rating: 4.95, status: 'verified', city: 'Tokyo', flagged: false },
  { id: 'C-3193', name: 'Ingrid Solberg', email: 'i@solberg.no', joined: '2023-12-01', trips: 4, spent: 880, rating: 4.91, status: 'verified', city: 'Oslo', flagged: false },
  { id: 'C-3192', name: 'Olamide Adeyemi', email: 'ola@ade.ng', joined: '2024-02-19', trips: 1, spent: 0, rating: 0, status: 'pending', city: 'Lagos', flagged: false },
  { id: 'C-3191', name: 'Pavel Novak', email: 'pavel@cz', joined: '2023-05-28', trips: 6, spent: 1240, rating: 4.83, status: 'verified', city: 'Prague', flagged: false },
];

export interface MockFinanceWeek {
  week: string;
  gmv: number;
  take: number;
  refunds: number;
  claims: number;
}

export const MOCK_FINANCE: { weekly: MockFinanceWeek[] } = {
  weekly: [
    { week: 'W14', gmv: 184000, take: 41200, refunds: 2400, claims: 800 },
    { week: 'W15', gmv: 192000, take: 42800, refunds: 1800, claims: 1100 },
    { week: 'W16', gmv: 211000, take: 47100, refunds: 3200, claims: 600 },
    { week: 'W17', gmv: 218000, take: 48900, refunds: 2100, claims: 1400 },
    { week: 'W18', gmv: 234000, take: 52400, refunds: 2800, claims: 900 },
    { week: 'W19', gmv: 248000, take: 55600, refunds: 1900, claims: 1200 },
    { week: 'W20', gmv: 261000, take: 58400, refunds: 2400, claims: 700 },
  ],
};

export interface MockAuditEntry {
  t: string;
  who: string;
  ev: string;
  target: string;
}

export const MOCK_AUDIT_LOG: MockAuditEntry[] = [
  { t: '14:32', who: 'You', ev: 'Approved KYC', target: 'V-052 · Sara Lopes' },
  { t: '14:18', who: 'Roberto · Support', ev: 'Refunded', target: 'BK-48190 · £165.00' },
  { t: '13:55', who: 'Anna · Finance', ev: 'Released payout', target: 'PY-19914 · £412.00' },
  { t: '13:42', who: 'System · Auto', ev: 'Locked account', target: 'C-3192 · 3 failed pays' },
  { t: '12:18', who: 'Felix · Trust & safety', ev: 'Escalated dispute', target: 'D-2103 · BK-48196' },
  { t: '11:30', who: 'Maya · Host ops', ev: 'Approved listing', target: 'CAR-1041 · BMW i4' },
];

export type ModuleId =
  | 'inbox'
  | 'dashboard'
  | 'bookings'
  | 'cars'
  | 'crew'
  | 'drivers'
  | 'rides'
  | 'airport-requests'
  | 'customers'
  | 'locations'
  | 'reviews'
  | 'inquiries'
  | 'support'
  | 'disputes'
  | 'complaints'
  | 'pricing'
  | 'transfer-pricing'
  | 'newsletter'
  | 'partners'
  | 'partner-applications'
  | 'claims'
  | 'payouts'
  | 'host-payouts'
  | 'vendor-statements'
  | 'finance'
  | 'reports'
  | 'settings'
  | 'admin-users'
  | 'configs'
  | 'audit-log'
  | 'templates'
  | 'attributes'
  | 'vehicle-catalog'
  | 'needs-linking'
  | 'vehicle-requests'
  | 'health';

export type ModuleGroup = 'overview' | 'operate' | 'vehicles' | 'trust' | 'commerce' | 'finance' | 'system';

export interface AdminModule {
  id: ModuleId;
  label: string;
  icon: string;
  group: ModuleGroup;
}

// Static module registry — defines the sidebar shape. "Needs attention"
// counts overlay this at runtime via `/admin/attention` polling; we no
// longer carry mock counts on the static record. Disputes/complaints/
// claims have no live source yet (operational pipeline pending) so their
// badges stay blank until those land.
/** Modules that exist only for the airport-transfers product. Hidden from the
 *  sidebar while transfers are off (lib/features.ts); their routes answer
 *  with a short notice instead of the screen. */
export const TRANSFER_MODULES: ReadonlySet<ModuleId> = new Set<ModuleId>([
  'drivers', 'rides', 'airport-requests', 'transfer-pricing',
]);

export const ADMIN_MODULES: AdminModule[] = [
  { id: 'inbox', label: 'Inbox', icon: 'bell', group: 'overview' },
  { id: 'dashboard', label: 'Dashboard', icon: 'home', group: 'overview' },
  { id: 'bookings', label: 'Bookings', icon: 'cal', group: 'operate' },
  { id: 'cars', label: 'Cars · Fleet', icon: 'car', group: 'operate' },
  { id: 'crew', label: 'Crew', icon: 'users', group: 'operate' },
  // Deliberately its own entry, not nested under Crew: a crew is a company,
  // a driver is a licensed individual with documents and per-city eligibility.
  { id: 'drivers', label: 'Drivers', icon: 'user', group: 'operate' },
  // Walk-in rides: whose card is held, and where the car is. Next to Drivers
  // because that is who support is asked about.
  { id: 'rides', label: 'Rides', icon: 'car', group: 'operate' },
  // Crews asking for an airport we do not serve yet. Sits with the other
  // review queues in Operate.
  { id: 'airport-requests', label: 'Airport requests', icon: 'globe', group: 'operate' },
  { id: 'customers', label: 'Customers', icon: 'user', group: 'operate' },
  { id: 'locations', label: 'Locations', icon: 'globe', group: 'operate' },
  { id: 'reviews', label: 'Reviews', icon: 'star', group: 'trust' },
  { id: 'inquiries', label: 'Inquiries', icon: 'msg', group: 'trust' },
  { id: 'support', label: 'Support', icon: 'msg', group: 'trust' },
  { id: 'disputes', label: 'Disputes', icon: 'shield', group: 'trust' },
  { id: 'complaints', label: 'Complaints', icon: 'msg', group: 'trust' },
  { id: 'pricing', label: 'Pricing & promos', icon: 'tag', group: 'commerce' },
  { id: 'transfer-pricing', label: 'Transfer pricing', icon: 'tag', group: 'commerce' },
  { id: 'newsletter', label: 'Newsletter', icon: 'msg', group: 'commerce' },
  // The partner accounts themselves (credentials, products, booking mode,
  // origins). The /partners route and its permission existed from the start;
  // only this sidebar entry was missing, so the page was reachable by URL alone.
  { id: 'partners', label: 'Partners', icon: 'users', group: 'commerce' },
  { id: 'partner-applications', label: 'Partner applications', icon: 'users', group: 'commerce' },
  { id: 'claims', label: 'Insurance & claims', icon: 'umbrella', group: 'commerce' },
  { id: 'payouts', label: 'Payouts', icon: 'bank', group: 'finance' },
  { id: 'host-payouts', label: 'Host payouts', icon: 'bank', group: 'finance' },
  // The other direction of crew money: what a crew OWES DriveCars on
  // supplier-commission sales. Next to the payouts it settles against.
  { id: 'vendor-statements', label: 'Supplier commission', icon: 'bank', group: 'finance' },
  { id: 'finance', label: 'Finance', icon: 'graph', group: 'finance' },
  { id: 'reports', label: 'Reports', icon: 'chart', group: 'finance' },
  { id: 'settings', label: 'Settings & RBAC', icon: 'gear', group: 'system' },
  { id: 'admin-users', label: 'Backoffice users', icon: 'users', group: 'system' },
  { id: 'configs', label: 'Platform configs', icon: 'gear', group: 'system' },
  { id: 'audit-log', label: 'Audit log', icon: 'shield', group: 'system' },
  { id: 'templates', label: 'Templates', icon: 'msg', group: 'system' },
  { id: 'attributes', label: 'Attributes', icon: 'tag', group: 'vehicles' },
  { id: 'vehicle-catalog', label: 'Vehicle Catalog', icon: 'car', group: 'vehicles' },
  { id: 'needs-linking', label: 'Needs linking', icon: 'tag', group: 'vehicles' },
  { id: 'vehicle-requests', label: 'Vehicle requests', icon: 'car', group: 'vehicles' },
  { id: 'health', label: 'System health', icon: 'dot', group: 'system' },
];

// Backoffice staff roles — mirror of apps/api/src/core/auth/permissions.ts.
// `super_admin` sees every module (no gate). Other roles enumerate exactly
// which modules appear in their sidebar. The list of modules below maps to
// the `Section` enum in apps/backoffice/src/lib/permissions.ts.
//
// Source of truth for role bundles + section definitions:
// docs/superpowers/specs/2026-05-29-backoffice-roles-design.md

export type RoleId = 'super_admin' | 'operations' | 'finance' | 'marketing' | 'support' | 'viewer';

export interface RolePerm {
  label: string;
  /** Sidebar modules visible to this role. `'all'` for super_admin. */
  modules: ModuleId[] | 'all';
  /** Hint for the UI — viewer role is read-only on every section it sees.
   *  Not currently enforced (no RW split per the spec), but kept for the
   *  switcher's UX hint badge. */
  readonly: boolean;
}

export const ROLE_PERMS: Record<RoleId, RolePerm> = {
  super_admin: { label: 'Super admin', modules: 'all', readonly: false },
  operations: {
    label: 'Operations',
    modules: [
      'dashboard', 'inbox',
      'bookings', 'cars', 'crew', 'drivers', 'rides', 'airport-requests', 'customers', 'locations',
      'reviews', 'inquiries', 'support', 'disputes', 'complaints',
      'partners', 'partner-applications', 'attributes', 'vehicle-catalog', 'needs-linking', 'vehicle-requests',
    ],
    readonly: false,
  },
  finance: {
    label: 'Finance',
    modules: [
      'dashboard', 'bookings', 'payouts', 'host-payouts', 'vendor-statements',
      'finance', 'reports', 'pricing',
      'transfer-pricing',
    ],
    readonly: false,
  },
  marketing: {
    label: 'Marketing',
    modules: [
      'dashboard', 'newsletter', 'pricing', 'reports', 'templates',
    ],
    readonly: false,
  },
  support: {
    label: 'Support',
    modules: [
      'dashboard', 'inbox', 'bookings', 'customers', 'crew', 'drivers', 'rides',
      'reviews', 'inquiries', 'support', 'disputes', 'complaints',
    ],
    readonly: false,
  },
  viewer: {
    label: 'Viewer',
    modules: ['dashboard', 'reports', 'audit-log'],
    readonly: true,
  },
};
